import { UserDiscountCoupon, UserDiscountCouponSearchQuery } from '@models/user-discount-coupon';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createSafeStorage, createSizePartialize } from '@utils/localStorage';

const PAGE_SIZE = 20;

interface UserDiscountCouponsContainer {
  contents: UserDiscountCoupon[];
  page: number;
  size: number;
  total: number;
  hasNext: boolean;
}

interface UserDiscountCouponsStoreProps {
  searchResultContainer: UserDiscountCouponsContainer;
  searchQuery: UserDiscountCouponSearchQuery;
  searchKeyword?: string;
  setSearchKeyword: (keyword: string) => void;
  updateSearchQuery: (query: { [key: string]: any }) => void;
  resetSearchQuery: () => void;
  setUserDiscountCouponsContainer: (result: any) => void;
}

export const useUserDiscountCouponsStore = create(
  persist<UserDiscountCouponsStoreProps>(
    (set) => ({
      searchResultContainer: {
        contents: [] as UserDiscountCoupon[],
        total: 0,
        page: 0,
        size: 0,
        hasNext: false,
      },
      searchQuery: {
        page: 0,
        size: PAGE_SIZE,
        status: 'all',
      },
      searchKeyword: undefined,
      setUserDiscountCouponsContainer: (result) => {
        set((state) => {
          // 메모리 효율성을 위해 실제 데이터만 저장
          const newValue = {
            ...state.searchResultContainer,
            ...result,
            contents: result?.contents || [],
          };
          return { ...state, searchResultContainer: newValue };
        });
      },
      setSearchKeyword: (keyword: string) => {
        set((state) => {
          return {
            ...state,
            searchKeyword: keyword,
            searchResultContainer: { ...state.searchResultContainer, size: 0 },
          };
        });
      },
      updateSearchQuery: (query: { [key: string]: any }) => {
        set((state) => {
          return {
            ...state,
            searchQuery: { ...state.searchQuery, page: 0, ...query },
            searchResultContainer: { ...state.searchResultContainer, size: 0 },
          };
        });
      },
      resetSearchQuery: () => {
        set({
          searchQuery: {
            page: 0,
            size: PAGE_SIZE,
            status: 'all',
          },
        });
      },
    }),
    {
      name: 'igogo-admin-user-discount-coupons',
      storage: createSafeStorage(),
      partialize: createSizePartialize<UserDiscountCouponsStoreProps>(100), // 최대 100개 항목만 저장
    },
  ),
);
